import { qx_eDIOState_enum } from '@/graphql/types';
import { FaIconComplex } from '@/types';

export const SENSOR_DEFAULT_ICON = 'sensor-on';

export const getSensorStatusIcon = (
  state: qx_eDIOState_enum,
  parentDisconnected: boolean = false,
  disabledByLicense: boolean = false,
  enabled: boolean = true
): FaIconComplex => {

  // Disabled
  if (!enabled) {
    return {
      tooltip: 'Disabled',
      color: 'grey',
      iconStyle: 'fas',
      icon: 'sensor-off'
    };
  }

  // Parent (Gateway or Device) not connected
  if (parentDisconnected) {
    return {
      tooltip: 'Unknown',
      color: 'grey',
      iconStyle: 'fas',
      icon: 'sensor-off'
    };
  }

  // Disabled by License has a custom icon
  if (disabledByLicense) {
    return {
      tooltip: 'Disabled by License',
      color: 'grey',
      iconStyle: 'fas',
      icon: 'sensor-off'
    };
  }

  if (state === qx_eDIOState_enum.Trigger) {
    return {
      tooltip: state,
      color: 'danger',
      iconStyle: 'fas',
      icon: SENSOR_DEFAULT_ICON,
      mask: 'triangle',
      transform: 'grow-2',
      opacity: '1',
      subIcon: 'triangle-exclamation',
      subColor: 'info',
      subTransform: 'shrink-2'
    };
  }

  if (state === qx_eDIOState_enum.Alarm) {
    return {
      tooltip: state,
      color: 'danger',
      iconStyle: 'fas',
      icon: SENSOR_DEFAULT_ICON,
      mask: 'triangle',
      transform: 'grow-2',
      opacity: '1',
      subIcon: 'triangle-exclamation',
      subColor: 'info',
      subTransform: 'shrink-2'
    };
  }

  if (state === qx_eDIOState_enum.Fault) {
    return {
      tooltip: state,
      color: 'grey',
      iconStyle: 'fas',
      icon: SENSOR_DEFAULT_ICON,
      mask: 'triangle',
      transform: 'grow-2',
      opacity: '1',
      subIcon: 'triangle-exclamation',
      subColor: 'orange',
      subTransform: 'shrink-2'
    };
  }

  if (state === qx_eDIOState_enum.Normal) {
    return {
      tooltip: state,
      color: 'success',
      iconStyle: 'fas',
      icon: SENSOR_DEFAULT_ICON,
      transform: 'grow-2',
      opacity: '1',
    };
  }

  // if status is not found, display a generic icon
  return {
    tooltip: state,
    color: 'grey',
    iconStyle: 'fas',
    icon: SENSOR_DEFAULT_ICON,
    mask: 'triangle',
    transform: 'grow-2',
    opacity: '1',
    subColor: 'orange',
    subIcon: 'question',
    subMask: 'triangle',
    subTransform: 'shrink-7 down-2',
    subStyle: {
      transform: 'scale(0.9) !important'
    }
  };
};
